import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountSettingsService } from '../services/account-settings.service';

// In general, we should NOT be importing services from other apps, but these will eventually come from a shared package
import { PageLoadingService } from '../../../../../src/app/services/page-loading.service';
import { BrowserWindowService } from '../../../../../src/app/services/browser-window.service';
import { WorkSessionService } from '../../../../../src/shared/services/work-session.service';

@NgModule({
    declarations: [

    ],
    imports: [
        CommonModule
    ],
    exports: [

    ],
    providers: [
        PageLoadingService,
        BrowserWindowService,
        AccountSettingsService,
        WorkSessionService
    ]
})

export class CoreModule { }
